import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormSchemaAction, FormSchemaActionTypes } from './form-schema.actions';
import { APS_FORMLY } from 'src/app/getcare-formly/aps-formly';

export const FormSchemaState: any = {};

export function FormSchemaReducers(state = APS_FORMLY): any {
  return state;
}

export function DropdownOptionsReducers(state = FormSchemaState, action: FormSchemaAction): any {
  switch (action.type) {
    case FormSchemaActionTypes.LoadDropdownOptions: {
      return action.payload;
    }
    default:
      return state;
  }
}
